import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"float":"right"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { style: {"float":"right"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Select to config the network", -1)
const _hoisted_5 = { style: {"margin-left":"50px"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }, "Network", -1)
const _hoisted_7 = { style: {"width":"200px"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }, "Storage", -1)
const _hoisted_9 = { style: {"width":"200px"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }, "Token", -1)
const _hoisted_12 = { style: {"width":"200px"} }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }, "ApiToken", -1)
const _hoisted_15 = { style: {"width":"200px"} }
const _hoisted_16 = { style: {"flex":"auto"} }

import { ref } from "vue"

// import { Resolution } from '@unstoppabledomains/resolution';

import * as tools from "../libs/tools"
import * as connect from "../libs/connect"
import * as network from "../libs/network"
import * as element from "../libs/element"

import * as constant from "../constant"

  
const __default__ = {
  name: 'NavBar',
  props: {
  },
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const logo = require('@/assets/logo.png');
const metamask = require('@/assets/metamask.svg');
// const resolution = new Resolution();
const userName = connect.connectState.userName;
const shortName = connect.connectState.shortName;
const userAddr = connect.connectState.userAddr;
const shortAddr = connect.connectState.shortAddr;
const networkName = ref("");
const activeIndex = connect.connectState.activeIndex;
const connectStatus = ref("Connect Wallet");
const showSwitchNetwork = ref(false);
const transactions = connect.connectState.transactions;
const transactionCount = connect.connectState.transactionCount;
const networkSelected = ref(connect.connectState.chainId);
const storageSelected = ref(connect.connectState.storage);
const tokenSelected = ref(connect.connectState.currency);
const apiTokenSelected = ref(connect.connectState.web3Storage==='' ? constant.web3StorageAppKey : connect.connectState.web3Storage);
const networkOptions = constant.chainList;
const tokenOptions = ref((constant.tokenList as any)[connect.connectState.chainId]);

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  if(transaction.search("https://") >= 0){
    return transaction;
  }

  for(const i in constant.chainList){
    if(connect.connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }

  return transaction;
}

//connect to metamask
const connectNetwork = async () => {
  await connect.networkConnect().then(async (res) => {
    if(res){
      element.elMessage('success', 'You have connected to the wallet.');
    }else{
      await connect.cancelConnect();
      userAddr.value = "";
      shortName.value = "";
      shortAddr.value = "";
      networkName.value = "";
      connectStatus.value = "Connect Wallet";

      element.elMessage('error', 'Connect to the wallet failed.');  
    }
         
  });
}

//set connect callback function
connect.connectState.connectCallback = async () => {
    userName.value = connect.connectState.userName.value;
    shortName.value = tools.shortString(userName.value);
    userAddr.value = connect.connectState.userAddr.value;
    shortAddr.value = tools.shortString(userAddr.value);

    networkName.value = network.getChainName(connect.connectState.chainId);
    connectStatus.value = "Cancel Connect";  
};

//disconnect from metamask
const disConnectNetwork = async () => {
    await connect.cancelConnect();

    connectStatus.value = "Connect Wallet";
    userName.value = "";
    shortName.value = "";
    userAddr.value = "";
    shortAddr.value = "";
    networkName.value = "";

    element.elMessage('warning', 'You have disconnected to the wallet.');                     
}

//on wallet address changed
const accountsChanged = async (accounts: string[]) => {
  if(accounts.length === 0){
    return await disConnectNetwork();
  }

  if(connectStatus.value === "Cancel Connect"){
    await connectNetwork();
    connect.connectState.searchCallback();
  }
}

connect.connectState.accountsChanged = accountsChanged;

// connect.accountsChanged(accountsChanged);

//on wallet network changed
const chainChanged = async () => {
  //clear transactions when network changed
  connect.connectState.transactions.value = new Array();
  connect.connectState.transactionCount.value = 0;

  if(!(await connect.connected())){
    return;
  }

  if(connectStatus.value === "Cancel Connect"){
    await connect.connectState.connectCallback();
    connect.connectState.searchCallback();
  } 
}

connect.connectState.chainChanged = chainChanged;

// connect.chainChanged(chainChanged); 

//on drawer open to switch network
const onDrawerOpen = async () => {
  networkSelected.value = connect.connectState.chainId;
  storageSelected.value = connect.connectState.storage;
  tokenSelected.value = connect.connectState.currency;
  tokenOptions.value = (constant.tokenList as any)[connect.connectState.chainId];

  //make sure token is avaiable in selected network
  for(const i in tokenOptions.value){
    if(tokenOptions.value[i] === tokenSelected.value){
      return;
    }
  }
  tokenSelected.value = tokenOptions.value[0];      
}

//on select the network
const onNetworkSelected = async () => {
  tokenOptions.value = (constant.tokenList as any)[networkSelected.value];
  for(const i in tokenOptions.value){
    if(tokenOptions.value[i] === tokenSelected.value){
      return;
    }
  }

  tokenSelected.value = tokenOptions.value[0];
}

//on cancel switch network clicked
const cancelSwitchNetwork = async () => {
  showSwitchNetwork.value = false;
}

//on confirm swithc network clicked
const confirmSwitchNetwork = async () => {
  try{

    showSwitchNetwork.value = false;

    if(Number(networkSelected.value) <= 0){
      element.elMessage('warning', 'Invalid network selected!');
      return;
    }

    const res = await network.switchNetwork(Number(networkSelected.value));
    if(!res){
      element.elMessage('warning', 'Switch network chain failed!');
      return;      
    }

    if(!(await connect.connected())){
      await connectNetwork();
    }

    connect.connectState.storage = storageSelected.value;

    if (storageSelected.value === 'bundlr'){
      connect.connectState.currency = tokenSelected.value;
    }

    if (storageSelected.value === 'filcoin'){
      if (apiTokenSelected.value === ''){
        apiTokenSelected.value = constant.web3StorageAppKey;
      }

      connect.connectState.web3Storage = apiTokenSelected.value;
    }

    element.elMessage('success', 'Config network success!');
  }catch(e){
    element.alertMessage(e);
  }
}

//on click to clear transtractions
const onClearTransactions = async () => {
  connect.connectState.transactions.value = new Array();
  connect.connectState.transactionCount.value = 0; 
}
//on click to copy address
const onClickToCopy = async (content:string) => {
  tools.clickToCopy(content);
  
  element.elMessage('success', 'Copy ' + content + ' to clipboard success.');     
};

//on click notify
const onClickNotify = async () => {
  transactionCount.value = 0;
}

//on connect clicked
const onConnect = async () => {
  if(connectStatus.value === "Cancel Connect"){      
    return await disConnectNetwork();
  } else {
    return await connectNetwork();
  }
};

//on switch network clicked
const onNetworkConfig = async () => {
  showSwitchNetwork.value = true;
}

//on menus selected
const handleSelect = (key: string, keyPath: string[]) => {
  activeIndex.value = key;

  tools.setUrlParamter('activeIndex', activeIndex.value);
};    

//login to wallet and switch to the target chain.
const login = async () => {
  await connectNetwork();
  await confirmSwitchNetwork();
  connect.connectState.searchCallback();
};

//try get activeIndex from the url paramter
try{
  activeIndex.value = String(tools.getUrlParamter('activeIndex'));
  if(activeIndex.value != '1' &&
    activeIndex.value != '2'){
    activeIndex.value = '1';
  }
}catch(e){
  activeIndex.value = '1';
}

//set activeIndex to connectState and location.href
connect.connectState.activeIndex.value = activeIndex.value;
tools.setUrlParamter('activeIndex', activeIndex.value);

//try connect to metamask
login();

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_bell = _resolveComponent("bell")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_avatar, {
                style: {"width":"40px","height":"40px","float":"right","margin-right":"10px","margin-top":"10px"},
                src: _unref(logo)
              }, null, 8, ["src"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 14 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              "default-active": _unref(activeIndex),
              class: "el-menu-demo",
              mode: "horizontal",
              ellipsis: false,
              "unique-opened": true,
              "background-color": "#606266",
              style: {"float":"left","width":"100%"},
              "text-color": "#fff",
              "active-text-color": "#ffd04b",
              onSelect: handleSelect
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mints")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "2" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Names")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["default-active"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_popover, {
              placement: "bottom-start",
              title: "Transactions",
              width: 200,
              trigger: "click"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  circle: "",
                  color: "#606266",
                  size: "large",
                  style: {"margin-top":"10px","float":"right"},
                  onClick: onClickNotify
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_badge, {
                      isDot: _unref(transactionCount)>0,
                      max: 99,
                      class: "item",
                      style: {"margin-top":"15px"},
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 20 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_bell)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["isDot"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_row, { gutter: 20 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transactions), (tx) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        key: tx,
                        span: 20
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            href: transactionExplorerUrl(tx),
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tools.shortString(tx)), 1)
                            ]),
                            _: 2
                          }, 1032, ["href"]),
                          _createVNode(_component_el_icon, {
                            onClick: ($event: any) => (onClickToCopy(tx)),
                            style: {"margin-left":"10px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_document_copy)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  style: {"float":"right"},
                  onClick: onClearTransactions
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Clear")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_popover, {
              placement: "bottom-start",
              title: networkName.value,
              width: 200,
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                (_unref(userName) != '')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickToCopy(_unref(userName)))),
                      style: {"margin-top":"17px","padding-right":"10px","float":"right"}
                    }, _toDisplayString(_unref(shortName)), 1))
                  : _createCommentVNode("", true),
                (_unref(userName) === '')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickToCopy(_unref(userAddr)))),
                      style: {"margin-top":"17px","padding-right":"10px","float":"right"}
                    }, _toDisplayString(_unref(shortAddr)), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_unref(userName) != '')
                  ? (_openBlock(), _createBlock(_component_el_row, {
                      key: 0,
                      gutter: 20
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (onClickToCopy(_unref(userName)))),
                          style: {"margin-top":"17px"}
                        }, _toDisplayString(_unref(userName)), 1),
                        _hoisted_2
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_row, { gutter: 20 }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickToCopy(_unref(userAddr)))),
                      style: {"margin-top":"17px"}
                    }, _toDisplayString(_unref(userAddr)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_dropdown, {
                button: "",
                trigger: "click",
                style: {"width":"35px","height":"33px","float":"right","margin-right":"20px","margin-top":"10px"}
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        onClick: onConnect,
                        innerText: connectStatus.value
                      }, null, 8, ["innerText"]),
                      _createVNode(_component_el_dropdown_item, { onClick: onNetworkConfig }, {
                        default: _withCtx(() => [
                          _createTextVNode("Network Config")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_image, { src: _unref(metamask) }, null, 8, ["src"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_drawer, {
      modelValue: showSwitchNetwork.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showSwitchNetwork).value = $event)),
      direction: "rtl",
      "destroy-on-close": "",
      onOpen: onDrawerOpen
    }, {
      header: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_el_select, {
                modelValue: networkSelected.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((networkSelected).value = $event)),
                style: {"width":"200px"},
                placeholder: "Select Network",
                teleported: false,
                onChange: onNetworkSelected,
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(networkOptions), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.chainName,
                      label: item.chainName,
                      value: item.chainId
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_el_select, {
                modelValue: storageSelected.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((storageSelected).value = $event)),
                style: {"width":"200px"},
                placeholder: "Select Storage",
                teleported: false,
                filterable: "",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    key: "filcoin",
                    label: "Filcoin Network",
                    value: "filcoin"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          (storageSelected.value==='bundlr')
            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("td", _hoisted_12, [
                  _createVNode(_component_el_select, {
                    modelValue: tokenSelected.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tokenSelected).value = $event)),
                    style: {"width":"200px"},
                    placeholder: "Select Network",
                    teleported: false,
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tokenOptions.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (storageSelected.value==='filcoin')
            ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("td", _hoisted_15, [
                  _createVNode(_component_el_input, {
                    modelValue: apiTokenSelected.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((apiTokenSelected).value = $event)),
                    style: {"width":"200px","margin-left":"10px"},
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_button, { onClick: cancelSwitchNetwork }, {
            default: _withCtx(() => [
              _createTextVNode("cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmSwitchNetwork
          }, {
            default: _withCtx(() => [
              _createTextVNode("confirm")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})